import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { CreateNewSI } from "../../../SchemaInfo/info";
import { createSISchema } from "../../../Schemas/Site Inspection/SI_create_schema";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcElectronics } from "react-icons/fc";
import {
  CompanyAssetsInfo,
  CompanyAssetsSchema,
} from "../../../Schemas/employee/company_assets_schema";
import CustomTextArea from "../../../CustomComponent/custom_textarea";

const EditCompanyAssets = () => {
  const [companyAssetsInfo, setCompanyAssetsInfo] = useState(CompanyAssetsInfo);
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [leadOwner, setLeadOwner] = useState();
  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, []);

  const handelSubmit = (values) => {
    values = {
      ...values,
      status:
        values.status === "assigned"
          ? "assigned"
          : values?.assignTo
          ? "pending"
          : "available",
    };
    let formdata = new FormData();
    for (let key in values) {
      formdata.append(key, values[key]);
    }
    setLoading(true);
    performRequest("PATCH", `/companyassets/updateassets/${id}`, formdata, {
      contentType: "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Assets details updated successfully!");
          navigate(`/company-assets/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/companyassets/getassetsById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          let { assignHistory, ...initialValues } = res.data;
          setCompanyAssetsInfo(initialValues);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcElectronics></FcElectronics>Edit Assets
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Assets</h2>
            </div>
            <Formik
              initialValues={companyAssetsInfo}
              validationSchema={CompanyAssetsSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="name" type="text" />
                        {props.touched.name && props.errors.name && (
                          <p className="text-danger">{props.errors.name}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Asset id
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="assetId" type="text" />
                        {props.touched.assetId && props.errors.assetId && (
                          <p className="text-danger">{props.errors.assetId}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="photo"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue("photo", e.target.files[0])
                          }
                        />
                        {props.touched.photo && props.errors.photo && (
                          <p className="text-danger">{props.errors.photo}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Price
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="price" type="text" />
                        {props.touched.price && props.errors.price && (
                          <p className="text-danger">{props.errors.price}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Assign to</label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="assignTo"
                          type="text"
                          disabled={props.values.status === "assigned"}
                        >
                          <option value="">Select assign to</option>
                          {leadOwner &&
                            leadOwner.map((state, index) => (
                              <option key={index} value={state?.id}>
                                {state?.userName}
                              </option>
                            ))}
                        </CustomSelect>
                        {props.touched.assignTo && props.errors.assignTo && (
                          <p className="text-danger">{props.errors.assignTo}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Assign date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="assignDate"
                          type="date"
                          disabled={props.values.status === "assigned"}
                        />
                        {props.touched.assignDate &&
                          props.errors.assignDate && (
                            <p className="text-danger">
                              {props.errors.assignDate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          name="description"
                          rows={4}
                          type="text"
                        />
                        {props.touched.description &&
                          props.errors.description && (
                            <p className="text-danger">
                              {props.errors.description}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Save Asset" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditCompanyAssets;
